module.exports = __webpack_public_path__ + "img/DNARepair-GBM_10X_WTA.2e01a5e0.png";